module.exports = __webpack_public_path__ + "static/media/services-submenu-gift-packs.4ab2a622.png";